<p-toast xmlns="http://www.w3.org/1999/html"/>
<p-confirmDialog/>

@if (loading()) {
  <div class="space-y-3">
    <p-skeleton height="200px" borderRadius="12px"></p-skeleton>
  </div>
} @else if (oferta()) {
  <section class="space-y-4">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-3">
        <h1 class="text-2xl font-bold">Oferta #{{ oferta()!.id }}</h1>
        <p-tag value="{{ oferta()!.tipoTarifa }}" severity="info"></p-tag>
      </div>

      <div class="flex gap-2">
        @if (!editMode()) {
          <p-button label="Comparar" icon="pi pi-chart-line" styleClass="p-button-text" (onClick)="comparar()"/>
          <p-button label="Editar" icon="pi pi-pencil" (onClick)="toggleEdit()"/>
        } @else {
          <p-button label="Eliminar" icon="pi pi-trash" styleClass="p-button-danger" (onClick)="confirmarEliminar()"/>
          <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-text" (onClick)="cancelEdit()"/>
          <p-button label="Guardar" icon="pi pi-check" (onClick)="saveEdit()" [loading]="saving()"/>
        }
      </div>
    </div>

    <div>
      <p-card class="shadow-xl rounded-xl w-full">
        @if (!editMode()) {
          <div>
            <h2 class="text-lg font-medium mb-2">Cliente</h2>
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div>
                <label for="nombreCliente" class="block mb-1 text-sm font-medium">Nombre Cliente</label>
                <input pInputText id="nombreCliente" [value]="oferta()!.nombreCliente" class="w-full" readonly/>
              </div>
              <div>
                <label for="cups" class="block mb-1 text-sm font-medium">CUPS</label>
                <input pInputText id="cups" [value]="oferta()!.cups" class="w-full" readonly/>
              </div>
              <div>
                <label for="compania" class="block mb-1 text-sm font-medium">Compañia</label>
                <input pInputText id="compania" [value]="oferta()!.companiaActual" class="w-full" readonly/>
              </div>
            </div>
            <div class="grid grid-cols-2 md:grid-cols-2 gap-4 mt-4">
              <div>
                <label for="createdAt" class="block mb-1 text-sm font-medium">Creada</label>
                <input pInputText id="createdAt" [value]="oferta()!.createdAt" class="w-full" readonly/>
              </div>
              <div>
                <label for="diasFactura" class="block mb-1 text-sm font-medium">Días factura</label>
                <input pInputText id="diasFactura" [value]="oferta()!.diasFactura" class="w-full" readonly/>
              </div>
            </div>
          </div>

          <div class="mt-6">
            <h2 class="text-lg font-medium mb-2">Potencias</h2>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label for="potenciaP1" class="block mb-1 text-sm font-medium">Potencia P1</label>
                <input pInputText id="potenciaP1" [value]="oferta()!.potenciaP1" class="w-full" readonly/>
              </div>
              <div>
                <label for="potenciaP2" class="block mb-1 text-sm font-medium">Potencia P2</label>
                <input pInputText id="potenciaP2" [value]="oferta()!.potenciaP2" class="w-full" readonly/>
              </div>
            </div>
          </div>

          <div class="mt-6">
            <h2 class="text-lg font-medium mb-2">Consumos</h2>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label for="consumoP1" class="block mb-1 text-sm font-medium">Consumo P1 (kWh)</label>
                <input pInputText id="consumoP1" [value]="oferta()!.consumoP1 | number:'1.0-6':'es-ES'" class="w-full"
                       readonly/>
              </div>
              <div>
                <label for="consumoP2" class="block mb-1 text-sm font-medium">Consumo P2 (kWh)</label>
                <input pInputText id="consumoP2" [value]="oferta()!.consumoP2 | number:'1.0-6':'es-ES'" class="w-full"
                       readonly/>
              </div>
              <div>
                <label for="consumoP3" class="block mb-1 text-sm font-medium">Consumo P2 (kWh)</label>
                <input pInputText id="consumoP3" [value]="oferta()!.consumoP3 | number:'1.0-6':'es-ES'" class="w-full"
                       readonly/>
              </div>
            </div>
          </div>

          <div class="mt-6">
            <h2 class="text-lg font-medium mb-2">Precios</h2>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label for="precioConsumidoP1" class="block mb-1 text-sm font-medium">Precio consumido P1</label>
                <input pInputText id="precioConsumidoP1"
                       [value]="oferta()!.precioConsumidoP1 | currency:'EUR':'symbol':'1.2-2':'es-ES'" class="w-full"
                       readonly/>
              </div>
              <div>
                <label for="precioConsumidoP2" class="block mb-1 text-sm font-medium">Precio consumido P2</label>
                <input pInputText id="precioConsumidoP2"
                       [value]="oferta()!.precioConsumidoP2 | currency:'EUR':'symbol':'1.2-2':'es-ES'" class="w-full"
                       readonly/>
              </div>
              <div>
                <label for="precioConsumidoP3" class="block mb-1 text-sm font-medium">Precio consumido P3</label>
                <input pInputText id="precioConsumidoP3"
                       [value]="oferta()!.precioConsumidoP3 | currency:'EUR':'symbol':'1.2-2':'es-ES'" class="w-full"
                       readonly/>
              </div>
              <div>
                <label for="precioTotalConsumido" class="block mb-1 text-sm font-medium">Precio Total
                  Consumido</label>
                <input pInputText id="precioTotalConsumido"
                       [value]="oferta()!.precioTotalConsumido | currency:'EUR':'symbol':'1.2-2':'es-ES'"
                       class="w-full"
                       readonly/>
              </div>
              <div>
                <label for="precioTotalPotencia" class="block mb-1 text-sm font-medium">Precio Total Potencia</label>
                <input pInputText id="precioTotalPotencia"
                       [value]="oferta()!.precioTotalPotencia | currency:'EUR':'symbol':'1.2-2':'es-ES'" class="w-full"
                       readonly/>
              </div>
            </div>
          </div>

          <div class="mt-6">
            <h2 class="text-lg font-medium mb-2">Impuestos y otros</h2>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label for="otrosCostes" class="block mb-1 text-sm font-medium">Otros costes</label>
                <input pInputText id="otrosCostes"
                       [value]="oferta()!.otrosCostes | currency:'EUR':'symbol':'1.2-2':'es-ES'" class="w-full"
                       readonly/>
              </div>
              <div>
                <label for="bonoSocial" class="block mb-1 text-sm font-medium">Bono social</label>
                <input pInputText id="bonoSocial"
                       [value]="oferta()!.bonoSocial | currency:'EUR':'symbol':'1.2-2':'es-ES'"
                       class="w-full" readonly/>
              </div>
              <div>
                <label for="regularizacionFinanciacionBs" class="block mb-1 text-sm font-medium">Regularización
                  Financiación BS</label>
                <input pInputText id="regularizacionFinanciacionBs"
                       [value]="oferta()!.regularizacionFinanciacionBs | currency:'EUR':'symbol':'1.2-2':'es-ES'"
                       class="w-full" readonly/>
              </div>
              <div>
                <label for="rdTopeGas" class="block mb-1 text-sm font-medium">RD 10/2022 Tope del gas</label>
                <input pInputText id="rdTopeGas" [value]="oferta()!.rdTopeGas | currency:'EUR':'symbol':'1.2-2':'es-ES'"
                       class="w-full" readonly/>
              </div>
              <div>
                <label for="descuento" class="block mb-1 text-sm font-medium">Descuento</label>
                <input pInputText id="descuento" [value]="oferta()!.descuento | currency:'EUR':'symbol':'1.2-2':'es-ES'"
                       class="w-full" readonly/>
              </div>
              <div>
                <label for="impuestoElectricidad" class="block mb-1 text-sm font-medium">Impuesto de
                  Electricidad</label>
                <input pInputText id="impuestoElectricidad"
                       [value]="oferta()!.impuestoElectricidad | currency:'EUR':'symbol':'1.2-2':'es-ES'" class="w-full"
                       readonly/>
              </div>
              <div>
                <label for="alquilerDeEquipos" class="block mb-1 text-sm font-medium">Alquiler de equipos</label>
                <input pInputText id="alquilerDeEquipos"
                       [value]="oferta()!.alquilerDeEquipos | currency:'EUR':'symbol':'1.2-2':'es-ES'" class="w-full"
                       readonly/>
              </div>
              <div>
                <label for="iva" class="block mb-1 text-sm font-medium">IVA (%)</label>
                <input pInputText id="iva" [value]="oferta()!.iva" class="w-full" readonly/>
              </div>
            </div>
          </div>
        } @else {
          <form [formGroup]="form">
            <div>
              <h2 class="text-lg font-medium mb-2">Cliente</h2>
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                <div>
                  <label for="nombreCliente" class="block mb-1 text-sm font-medium">Nombre Cliente</label>
                  <input pInputText id="nombreCliente" formControlName="nombreCliente" class="w-full"/>
                </div>
                <div>
                  <label for="cups" class="block mb-1 text-sm font-medium">CUPS</label>
                  <input pInputText id="cups" formControlName="cups" class="w-full"/>
                </div>
                <div>
                  <label for="companiaActual" class="block mb-1 text-sm font-medium">Compañía</label>
                  <input pInputText id="companiaActual" formControlName="companiaActual" class="w-full"/>
                </div>
              </div>

              <div class="grid grid-cols-2 md:grid-cols-2 gap-4 mt-4">
                <div>
                  <label for="tipoTarifa" class="block mb-1 text-sm font-medium">Tipo tarifa</label>
                  <p-dropdown id="tipoTarifa" formControlName="tipoTarifa" [options]="tarifas"
                              class="w-full"></p-dropdown>
                </div>
                <div>
                  <label for="diasFactura" class="block mb-1 text-sm font-medium">Días factura</label>
                  <p-inputNumber id="diasFactura" formControlName="diasFactura" [min]="1" [max]="90"
                                 class="w-full"></p-inputNumber>
                </div>
              </div>
            </div>

            <div class="mt-6">
              <h2 class="text-lg font-medium mb-2">Potencias</h2>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label for="potenciaP1" class="block mb-1 text-sm font-medium">Potencia P1</label>
                  <p-inputNumber id="potenciaP1" formControlName="potenciaP1" mode="decimal" [minFractionDigits]="0"
                                 [maxFractionDigits]="6" class="w-full"></p-inputNumber>
                </div>

                <div>
                  <label for="potenciaP2" class="block mb-1 text-sm font-medium">Potencia P2</label>
                  <p-inputNumber id="potenciaP2" formControlName="potenciaP2" mode="decimal" [minFractionDigits]="0"
                                 [maxFractionDigits]="6" class="w-full"></p-inputNumber>
                </div>
              </div>
            </div>

            <div class="mt-6">
              <h2 class="text-lg font-medium mb-2">Consumos</h2>
              <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label for="consumoP1" class="block mb-1 text-sm font-medium">Consumo P1 (kWh)</label>
                  <p-inputNumber id="consumoP1" formControlName="consumoP1" mode="decimal" [minFractionDigits]="0"
                                 [maxFractionDigits]="6" class="w-full"></p-inputNumber>
                </div>
                <div>
                  <label for="consumoP2" class="block mb-1 text-sm font-medium">Consumo P2 (kWh)</label>
                  <p-inputNumber id="consumoP2" formControlName="consumoP2" mode="decimal" [minFractionDigits]="0"
                                 [maxFractionDigits]="6" class="w-full"></p-inputNumber>
                </div>
                <div>
                  <label for="consumoP3" class="block mb-1 text-sm font-medium">Consumo P3 (kWh)</label>
                  <p-inputNumber id="consumoP3" formControlName="consumoP3" mode="decimal" [minFractionDigits]="0"
                                 [maxFractionDigits]="6" class="w-full"></p-inputNumber>
                </div>
              </div>
            </div>

            <div class="mt-6">
              <h2 class="text-lg font-medium mb-2">Precios</h2>
              <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label for="precioConsumidoP1" class="block mb-1 text-sm font-medium">Precio consumido P1</label>
                  <p-inputNumber id="precioConsumidoP1" formControlName="precioConsumidoP1" mode="currency"
                                 currency="EUR"
                                 locale="es-ES" class="w-full"></p-inputNumber>
                </div>
                <div>
                  <label for="precioConsumidoP2" class="block mb-1 text-sm font-medium">Precio consumido P2</label>
                  <p-inputNumber id="precioConsumidoP2" formControlName="precioConsumidoP2" mode="currency"
                                 currency="EUR"
                                 locale="es-ES" class="w-full"></p-inputNumber>
                </div>
                <div>
                  <label for="precioConsumidoP3" class="block mb-1 text-sm font-medium">Precio consumido P3</label>
                  <p-inputNumber id="precioConsumidoP3" formControlName="precioConsumidoP3" mode="currency"
                                 currency="EUR"
                                 locale="es-ES" class="w-full"></p-inputNumber>
                </div>
                <div>
                  <label for="precioTotalConsumido" class="block mb-1 text-sm font-medium">Precio Total
                    Consumido</label>
                  <p-inputNumber id="precioTotalConsumido" formControlName="precioTotalConsumido" mode="currency"
                                 currency="EUR" locale="es-ES" class="w-full" [readonly]="true"></p-inputNumber>
                </div>
                <div>
                  <label for="precioTotalPotencia" class="block mb-1 text-sm font-medium">Precio Total Potencia</label>
                  <p-inputNumber id="precioTotalPotencia" formControlName="precioTotalPotencia" mode="currency"
                                 currency="EUR" locale="es-ES" class="w-full"></p-inputNumber>
                </div>
              </div>
            </div>

            <div class="mt-6">
              <h2 class="text-lg font-medium mb-2">Impuestos y otros</h2>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label for="otrosCostes" class="block mb-1 text-sm font-medium">Otros costes</label>
                  <p-inputNumber id="otrosCostes" formControlName="otrosCostes" mode="currency" currency="EUR"
                                 locale="es-ES" class="w-full"></p-inputNumber>
                </div>
                <div>
                  <label for="bonoSocial" class="block mb-1 text-sm font-medium">Bono social</label>
                  <p-inputNumber id="bonoSocial" formControlName="bonoSocial" mode="currency" currency="EUR"
                                 locale="es-ES"
                                 class="w-full"></p-inputNumber>
                </div>
                <div>
                  <label for="regularizacionFinanciacionBs" class="block mb-1 text-sm font-medium">Regularización
                    Financiación BS</label>
                  <p-inputNumber id="regularizacionFinanciacionBs" formControlName="regularizacionFinanciacionBs"
                                 mode="currency" currency="EUR" locale="es-ES" class="w-full"></p-inputNumber>
                </div>
                <div>
                  <label for="rdTopeGas" class="block mb-1 text-sm font-medium">RD 10/2022 Tope del gas</label>
                  <p-inputNumber id="rdTopeGas" formControlName="rdTopeGas" mode="currency" currency="EUR"
                                 locale="es-ES"
                                 class="w-full"></p-inputNumber>
                </div>
                <div>
                  <label for="descuento" class="block mb-1 text-sm font-medium">Descuento</label>
                  <p-inputNumber id="descuento" formControlName="descuento" mode="currency" currency="EUR"
                                 locale="es-ES"
                                 class="w-full"></p-inputNumber>
                </div>
                <div>
                  <label for="impuestoElectricidad" class="block mb-1 text-sm font-medium">Impuesto de
                    Electricidad</label>
                  <p-inputNumber id="impuestoElectricidad" formControlName="impuestoElectricidad" mode="currency"
                                 currency="EUR" locale="es-ES" class="w-full"></p-inputNumber>
                </div>
                <div>
                  <label for="alquilerDeEquipos" class="block mb-1 text-sm font-medium">Alquiler de equipos</label>
                  <p-inputNumber id="alquilerDeEquipos" formControlName="alquilerDeEquipos" mode="currency"
                                 currency="EUR"
                                 locale="es-ES" class="w-full"></p-inputNumber>
                </div>
                <div>
                  <label for="iva" class="block mb-1 text-sm font-medium">IVA (%)</label>
                  <p-inputNumber id="iva" formControlName="iva" [min]="0" [max]="21" class="w-full"></p-inputNumber>
                </div>
              </div>
            </div>
          </form>
        }
      </p-card>
    </div>
  </section>
}
